exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sites-metrics .progress[data-v-bdb8347c] {\n  height: 20px;\n  border-radius: 0;\n}\n", ""]);

// exports
